module.exports = __webpack_public_path__ + "img/logo.579f5e5f.svg";